import { upArrow, pinElement, addElements } from './animations.js';
import { mobileNavigation } from './mobileNavigation.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

upArrow();
mobileNavigation();
pinElement();
addElements(40);

const navigationHeight = document.querySelector('header.wp-block-template-part').offsetHeight;
 
// console.log(document.documentElement);

if (!document.body.classList.contains('home')) {
  document.documentElement.style.setProperty('--scroll-padding', navigationHeight - 1 + 'px');
} else {
  console.log('working scroll trigger header');
  ScrollTrigger.create({
    trigger: 'wp-block-group.header',
    start: 'top -250px',
    end: '+=15000',
    toggleClass: { targets: 'body', className: 'scrolled' },
  });
}
//

//homepage golf
if (document.getElementById('header')) {
  var newElement = document.createElement('div');
  newElement.innerHTML = '<svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto"><defs><path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path></defs><g class="parallax"><use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(109,223,239,0.7"></use><use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(109,223,239,0.5)"></use><use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(109,223,239,0.7)"></use><use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,1)"></use></g></svg>';
  document.getElementById('header').getElementsByClassName('wp-block-cover__inner-container')[0].appendChild(newElement); 
}
